import {Link} from 'react-router-dom'

export function NotFound() {
  return (
    <div className="state-panel">
      <strong>Page not found</strong>
      <Link to="/">Return to portfolio dashboard</Link>
    </div>
  )
}
